@if (!businessId) {
<brt-business-list (selected)="router.navigate([basePath, 'menu', $event.Id, 'option'])"></brt-business-list>
} @else {
<div class="card">
  <h5>Menu Option List</h5>
  <p-table #dt1 [value]="menuOptions" dataKey="Id" [rows]="criteria.Size || 50" [loading]="loading" [rowHover]="true"
    styleClass="p-datatable-gridlines" [paginator]="true" [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
    responsiveLayout="scroll" [globalFilterFields]="[]" [lazy]="true" [totalRecords]="total" (onLazyLoad)="load($event)">
    <ng-template pTemplate="caption">
      <div class="tw-flex tw-flex-wrap tw-gap-2 tw-items-center tw-justify-between">
        <span class="p-input-icon-left tw-grow">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="criteria.Query" placeholder="Search option by name, tag, or ID"
            class="tw-w-full" (ngModelChange)="load()" />
        </span>
        <button pButton label="Add" class="mr-2" icon="pi pi-plus"
          [routerLink]="[basePath, 'menu', businessId, 'option', 'add']"></button>
        <div>
          {{menuOptions?.length|number}} menu options
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Type">
          <div class="tw-flex tw-gap-2 tw-items-center">
            <p-sortIcon field="Type" />
            <div class="tw-flex-grow">
              Type
            </div>
          </div>
        </th>
        <th pSortableColumn="Name">
          <div class="tw-flex tw-gap-2 tw-items-center">
            <p-sortIcon field="Name" />
            <div class="tw-flex-grow">
              Name
            </div>
          </div>
        </th>
        <th pSortableColumn="Price">
          <div class="tw-flex tw-gap-2 tw-items-center">
            <p-sortIcon field="Price" />
            <div class="tw-flex-grow">
              Price
            </div>
          </div>
        </th>
        <th>
          <div class="flex justify-content-between align-items-center">
            Actions
          </div>
        </th>
      </tr>
      <tr>
        <th>
          <p-dropdown [options]="optionTypes" [(ngModel)]="criteria.Type" placeholder="Filter type"
            [showClear]="true" appendTo="body" (onChange)="loadFromFirstPage()"></p-dropdown>
        </th>
        <th>
          <input pInputText type="text" [(ngModel)]="criteria.Name" placeholder="Filter name"
            class="tw-w-full" (ngModelChange)="loadFromFirstPage()" />
        </th>
        <th>
          <input pInputText type="number" [(ngModel)]="criteria.Price" placeholder="Filter price"
            class="tw-w-full" (ngModelChange)="loadFromFirstPage()" />
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-menuOption>
      <tr>
        <td>{{ menuOption.Type }}</td>
        <td>
          <img [src]="menuOption.UI?.Image" width="30" />
          <span class="image-text ml-2">{{ menuOption.Name }}</span>
        </td>
        <td>{{ menuOption.Price }}</td>
        <td>
          <!-- <button pButton class="p-button-outlined mr-2" icon="pi pi-pencil" title="Edit"
            [routerLink]="[basePath,'menu', businessId, 'option', menuOption.Id]"></button>
          <button (click)="deleteMenu(menuOption,$event)" pButton icon="pi pi-trash" title="Delete"
            class="p-button-danger mr-2"></button> -->
          <div class="flex align-items-center justify-content-center gap-2">
            <button pButton type="button" icon="pi pi-pencil" title="Edit"
              class="p-button-rounded p-button-text btn-min" [routerLink]="[
                basePath,
                'menu',
                businessId,
                'option',
                menuOption.Id
              ]"></button>
            <button pButton type="button" icon="pi pi-trash" title="Delete"
              class="p-button-rounded p-button-text p-button-danger btn-min"
              (click)="deleteMenuOption(menuOption, $event)"></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No menu found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <!-- <tr>
        <td colspan="8">Loading menu option data. Please wait.</td>
      </tr> -->
      <tr>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
      </tr>
      <tr>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
      </tr>
      <tr>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmPopup key="confirmPopup"></p-confirmPopup>
}